import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/** Score based on the lead time of problems resolution */
export default new VitalityCriterion({
  titleTr: 'VH_PB_LEAD_TIME',
  key: 'problemLeadTime',
  weight: 1,
  score: ({ problems }, range, { lastRange }) => {
    // Number of problems in the range
    let nInPeriod = 0;
    // Sum of problem lead times in the range in hours
    let totalDiff = 0;
    let nInPrev = 0;
    let totalDiffInPrev = 0;
    for (let i = 0, len = problems.length; i < len; i++) {
      const pb = problems[i];
      if (pb.state < 4 || pb.lastActionResolution === null) {
        continue;
      }
      const mDate = Moment(pb.lastActionResolution);
      if (mDate.isAfter(range.start) && mDate.isBefore(range.end)) {
        totalDiff += mDate.diff(pb.created, 'hour');
        nInPeriod++;
      } else if (mDate.isBefore(range.start) && mDate.isAfter(lastRange.start)) {
        totalDiffInPrev += mDate.diff(pb.created, 'hour');
        nInPrev++;
      }
    }
    const avgLeadTime = nInPeriod === 0 ? 0 : totalDiff / nInPeriod;
    const avgLeadTimeInPrev = nInPrev === 0 ? 0 : totalDiffInPrev / nInPrev;
    let increasePerc = 0;
    if (avgLeadTimeInPrev === 0 && avgLeadTime > 0) {
      increasePerc = 100;
    } else if (avgLeadTimeInPrev > 0) {
      increasePerc = ((avgLeadTime - avgLeadTimeInPrev) / avgLeadTimeInPrev) * 100;
    }
    // f(x) = -0.8*x + 55
    let score = 0;
    if (avgLeadTimeInPrev > 0 || avgLeadTime > 0) {
      score = -0.8 * increasePerc + 55;
    }

    return {
      score: score.sBetweenBoundaries(0, 100),
      data: {
        noTopsFlops: nInPeriod === 0,
        noCategoryHint: nInPeriod === 0,
        value: increasePerc,
        hoursValue: avgLeadTime,
      },
    };
  },

  text({ value, hoursValue }) {
    let nHours = hoursValue;
    let nDays = 0;
    if (hoursValue > 24) {
      nDays = Math.floor(hoursValue / 24);
      nHours -= 24 * nDays;
    }
    let displayTime = '';
    if (hoursValue === 0) {
      displayTime = i18n.t('message.NO_COMPLETED_PROBLEMS');
    } else {
      if (nDays > 0) {
        displayTime += `${i18n.tc('message.N_DAYS', nDays, { nb: nDays })}`;
      }
      if (nHours > 0) {
        if (nDays > 0) {
          displayTime += ' ';
        }
        displayTime += `${i18n.tc('message.N_HOURS', nHours, { nb: nHours.toFixed(0) })}`;
      }
    }
    // Display either VH_PB_LEAD_TIME_TEXT_INC or VH_PB_LEAD_TIME_TEXT_DEC
    return i18n.t(
      `message.VH_PB_LEAD_TIME_TEXT_${value >= 0 ? 'INC' : 'DEC'}`,
      { val: Math.abs(value).sToFixed(1), displayTime },
    );
  },
});
